import React, { Component, Fragment } from 'react';
import { Menu, Icon } from 'semantic-ui-react';
import { SignOut } from 'aws-amplify-react';

export default class MainMenu extends Component {

    constructor(props) {
      super(props);
      this.state = { activeItem: 'countries' };
    }

    handleItemClick = (e, { name }) => {
        this.setState({ activeItem: name });
        this.props.onSelected(name);
    }

    getLogoutTheme = () => {
        return {
            navButton: {
                color: 'black',
                padding: '.8em',
                backgroundColor: 'white',
                borderRadius: '0.2em',
                fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
                fontSize: '.8rem',
                minWidth: '0'
            }
        }
    }

    render() {
        const { activeItem } = this.state

        return (
            <Fragment>
                <Menu pointing>
                    <Menu.Item name='countries' active={activeItem === 'countries'} onClick={this.handleItemClick} >
                        <Icon name='globe' />
                        Countries
                    </Menu.Item>
                    <Menu.Item name='fees' active={activeItem === 'fees'} onClick={this.handleItemClick} >
                        <Icon name='dollar sign' />
                        Fees
                    </Menu.Item>
                    <Menu.Item name='gallery' active={activeItem === 'gallery'} onClick={this.handleItemClick} >
                        <Icon name='picture' />
                        Project Gallery
                    </Menu.Item>

                    <Menu.Menu position='right'>
                        <Menu.Item>
                            <SignOut theme={this.getLogoutTheme()} />
                            <Icon name='log out' />
                        </Menu.Item>
                    </Menu.Menu>
                </Menu>
          </Fragment>
        )
    }
}
